import {Checkbox} from "antd";
import React, {useContext, useEffect, useState} from "react";
import {OrganizationServiceContext} from "../../Contexts";
import Organization from "../../domain/Organization";
import QueryOptions from "../../sal-ui/QueryOptions";
import {FilterItem, FilterItemProps, SelectEditor} from "../tablefilter/TableFilter";
import {SearchFilter} from "../tablefilter/SearchFilter";

interface OrganizationItemProps extends FilterItemProps {
    organizations?: Organization[];
}

function OrganizationItem(props: OrganizationItemProps) {
    return (
        <SelectEditor
            width={180}
            multiple={true}
            showSearch={true}
            optionFilterProp="label"
            options={props.organizations?.map(organization => ({
                value: organization.id,
                label: organization.name
            }))}
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    );
}

function EnabledItem(props: FilterItemProps) {
    return (
        <Checkbox checked={props.value} onChange={value => props.onChange(value.target.checked)}/>
    );
}

interface VulReportDefinitionFilterProps {
    className?: string;
    values?: any;
    onChange: (values: any) => void;
    showOrganization: boolean;
    persistentStateIdent?: string;
}

export function createDefaultVulReportDefinitionFilterValues() {
    return {organizationIds: [], enabled: undefined};
}

function VulReportDefinitionFilter(props: VulReportDefinitionFilterProps) {
    const organizationService = useContext(OrganizationServiceContext);
    const [organizations, setOrganizations] = useState<Organization[]>();

    useEffect(() => {
        if (!props.showOrganization) {
            return;
        }

        organizationService.getList(QueryOptions.newUnlimitedOrderedInstance("name"))
            .then(result => setOrganizations(result.data));
    }, [organizationService, props.showOrganization]);

    const items: FilterItem[] = [
        {
            name: "enabled",
            key: "enabled",
            label: "Enabled",
            labelCursor: "pointer",
            initialValue: true,
            onLabelClick: () => props.onChange({
                ...props.values,
                enabled: !props.values?.enabled
            }),
            render: itemProps => <EnabledItem {...itemProps}/>
        }
    ];

    if (props.showOrganization) {
        items.unshift({
            name: "organizationIds",
            key: "organizationIds",
            label: "Organization",
            render: itemProps => <OrganizationItem {...itemProps} organizations={organizations}/>
        });
    }

    return (
        <SearchFilter
            items={items}
            className={props.className}
            values={props.values}
            defaultValues={createDefaultVulReportDefinitionFilterValues()}
            persistentStateIdent={props.persistentStateIdent}
            defaultActiveFilterNames={["organizationIds", "enabled"]}
            onChange={props.onChange}
        />
    );
}

export default VulReportDefinitionFilter;
